import { combineReducers } from 'redux';
import rctAccuracyReducer from './rctAccuracyReducer';
import rctFluCompReducer from './rctFluCompReducer';

const rctReducers = {
    accuracy: rctAccuracyReducer,
    fluComp: rctFluCompReducer,
};

const rctReducer = combineReducers(rctReducers);

export default rctReducer;
